import { render, staticRenderFns } from "./My-Form-pc.vue?vue&type=template&id=cc388b50&scoped=true"
import script from "./My-Form-pc.vue?vue&type=script&lang=js"
export * from "./My-Form-pc.vue?vue&type=script&lang=js"
import style0 from "./My-Form-pc.vue?vue&type=style&index=0&id=cc388b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc388b50",
  null
  
)

export default component.exports